import React from 'react';
import { NavLink } from 'react-router-dom';
import config from '../../config/config';
import { ReactComponent as ButtonIcon } from '../../images/noun-get-started.svg';

const AddNewTrip = (props) => {
	return (
		<>
			<NavLink
				className='homepage__subnav-button'
				to={config.SignedInLinks.createTrip}>
				Get Started
				<ButtonIcon />
			</NavLink>
		</>
	);
};

export default AddNewTrip;
